export class Organization { }
